export class Organization { }
